import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";
import { getUserData } from "../utils/authnicate";

/**
 * Submits ledger status for an entity.
 * POST api/Onboarding/entity-ledger-status
 *
 * @param {{
 *   entityPrimaryId: number,
 *   entityId: string,
 *   isLedger: boolean,
 *   isLedgerSendByEmail: boolean,
 *   ledgerName: string,
 *   fileName: string,
 *   filePath: string,
 *   email: string,
 * }} params
 */
export const entityLedgerStatusAction = async ({
  entityPrimaryId,
  entityId,
  isLedger,
  isLedgerSendByEmail,
  ledgerName,
  fileName,
  filePath,
  email,
}) => {
  try {
    const user = getUserData();
    const payload = {
      entityPrimaryId: entityPrimaryId || 0,
      isLedger: String(!!isLedger), // API expects string: "true" / "false"
      isLedgerSendByEmail: !!isLedgerSendByEmail,
      entityId: entityId || "",
      ledgerName: ledgerName || "",
      fileName: fileName || "",
      filePath: filePath || "",
      createdBy: user?.userName || "",
      email: email || "",
    };

    const response = await apiClient.post(
      ATP_API_URL.ENTITY_LEDGER_STATUS,
      payload,
    );

    if (response?.status === 200) {
      return {
        success: true,
        data: response.data,
        message: response.data?.message || "Ledger status updated",
      };
    }
    return { success: false, message: "Failed to update ledger status" };
  } catch (error) {
    return { success: false, message: error.message };
  }
};
